import React from 'react';
import { useHistory } from 'react-router-dom';
import { Button, Modal } from '@ver-uds/react';
import { getUserData } from '@save/utils';

export default function TrainingModal() {
  const history = useHistory();
  const userData = getUserData();

  return !userData.tutorialComplete ? (
    <Modal
      id="save-training-modal"
      header="SAVE Required Updates and Tutorial"
      open
      close={function close() {}}
      hasDismissButton={false}
    >
      <Modal.Content>
        <p>
          To help ensure proper SAVE use and provide users with important SAVE knowledge and resources, SAVE is
          requiring users to update and confirm their contact information as well as complete a short, annual web-based
          refresher tutorial. Failure to complete these steps will result in SAVE user account suspension.
        </p>
        <p>
          To update and confirm your contact information and complete the tutorial, please click on your name in the
          upper right hand corner and then click "Manage Profile."
        </p>
        <p>Thank you for using SAVE.</p>
      </Modal.Content>
      <Modal.Footer>
        <Button onClick={() => history.push('/save/app/client/ui/profile/edit')} type="button" variant="primary">
          Continue
        </Button>
      </Modal.Footer>
    </Modal>
  ) : (
    <></>
  );
}
